import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function HedgeFunds({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/SavingsDef");
    };

    const goPrev = () => {
        navigate("/MarketAndTargetFunds");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Hedge Funds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-2xl mt-3">
                    A hedge fund is a fund that uses a wide range of strategies to earn above-
                </div>
                <div className="text-[#000000] text-2xl">
                    average investment returns.  It can use non-traditional assets of private investors 
                </div>
                <div className="text-[#000000] text-2xl">
                    and are highly risky.  To even start using a hedge fund, you must have a very high 
                </div>
                <div className="text-[#000000] text-2xl">
                    initial deposit or a high net worth.
                </div>
                <div className="text-[#000000] text-2xl mt-3">
                    4 common types of hedge funds are global macro hedge funds, equity hedge 
                </div>
                <div className="text-[#000000] text-2xl">
                    funds, relative value hedge funds, and activist hedge funds.
                </div>
                <div className="text-[#000000] text-2xl mt-3">
                    A global macro hedge fund attempts to profit from market swings caused by 
                </div>
                <div className="text-[#000000] text-2xl">
                    political or economic events.  An equity hedge fund invests in highly
                </div>
                <div className="text-[#000000] text-2xl">
                    profitable stocks and counterss downturns by shorting overvalued stocks.
                </div>
                <div className="text-[#000000] text-2xl">
                    A relative value hedge fund exploits price and spread inefficiencies.
                </div>
                <div className="text-[#000000] text-2xl">
                    An activist hedge fund invests in business and takes actions to boost the stock 
                </div>
                <div className="text-[#000000] text-2xl">
                    price of the business through abnormal means.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}